import * as React from "react";
const SvgIconStacked = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#b1bac6", fillRule: "evenodd", d: "M11 13v7H4v-7h7zm9 0v7h-7v-7h7zm-9-9v7H4V4h7zm9 0v7h-7V4h7z" }));
export default SvgIconStacked;
